export const tunewsLabel = 'tünews INTERNATIONAL'
